import { FunctionComponent } from "react";

import { ReactComponent as Warning } from "@src/modules/shared/components/WarningMessage/icons/warning.svg";
import { WarningContainer } from "@src/modules/shared/components/WarningMessage/WarningMessage.components";

const WarningMessage: FunctionComponent = ({ children }) => (
  <WarningContainer>
    <Warning />
    {children}
  </WarningContainer>
);

export default WarningMessage;
